/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hassiblingsatmartinusschools4Inputs */



/**

* @param {_Field_Hassiblingsatmartinusschools4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hassiblingsatmartinusschools4 = /** @type {((inputs?: _Field_Hassiblingsatmartinusschools4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hassiblingsatmartinusschools4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Geschwister an einer Schule der Schulgesellschaft")
});
export { _field_hassiblingsatmartinusschools4 as "_field_hasSiblingsAtMartinusSchools" }